import store from '@state/store'

export default [
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@views/home')),
    meta: {
      authRequired: true,
      title: 'Dashboard',
      authorize: ['admin', 'college', 'teacher', 'hod', 'administrator'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/student-list',
    name: 'student.list',
    component: () => lazyLoadView(import('@views/student/list')),
    meta: {
      authRequired: true,
      title: 'Student List',
      authorize: ['admin', 'college', 'teacher', 'hod', 'administrator'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/student-add',
    name: 'student.add',
    component: () => lazyLoadView(import('@views/student/add')),
    meta: {
      authRequired: true,
      title: 'Add Student',
      authorize: ['admin', 'college', 'teacher', 'administrator', 'hod'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/student-addbulk',
    name: 'student.addbulk',
    component: () => lazyLoadView(import('@views/student/addbulk')),
    meta: {
      authRequired: true,
      title: 'Add Student In Bulk',
      authorize: ['admin', 'college', 'teacher', 'administrator', 'hod'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/meeting-list',
    name: 'meeting.list',
    component: () => lazyLoadView(import('@views/meeting/list')),
    meta: {
      authRequired: true,
      title: 'Live Class List',
      authorize: ['college', 'teacher', 'administrator', 'hod', 'admin'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/meeting-add',
    name: 'meeting.add',
    component: () => lazyLoadView(import('@views/meeting/addMeeting')),
    meta: {
      authRequired: true,
      title: 'Add Live Class',
      authorize: ['college', 'teacher', 'administrator', 'hod'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/meeting-start/:meetingId/:password',
    name: 'meeting.start',
    component: () => lazyLoadView(import('@views/meeting/startMeeting')),
    meta: {
      authRequired: true,
      title: 'Start Meeting',
      authorize: ['college', 'teacher', 'administrator', 'hod'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/category-list',
    name: 'category.list',
    component: () => lazyLoadView(import('@views/category/list')),
    meta: {
      authRequired: true,
      title: 'Category List',
      authorize: ['college', 'admin', 'administrator'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/category-add',
    name: 'category.add',
    component: () => lazyLoadView(import('@views/category/add')),
    meta: {
      authRequired: true,
      title: 'Add Category',
      authorize: ['college', 'admin', 'administrator'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/subcategory-list',
    name: 'subcategory.list',
    component: () => lazyLoadView(import('@views/category/subList')),
    meta: {
      authRequired: true,
      title: 'Subcategory List',
      authorize: ['college', 'admin', 'administrator'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/subcategory-add',
    name: 'subcategory.add',
    component: () => lazyLoadView(import('@views/category/subAdd')),
    meta: {
      authRequired: true,
      title: 'Add Subcategory',
      authorize: ['college', 'admin', 'administrator'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/user-list',
    name: 'user.list',
    component: () => lazyLoadView(import('@views/user/list')),
    meta: {
      authRequired: true,
      title: 'Student List',
      authorize: ['admin', 'college', 'teacher', 'hod', 'administrator'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/admin-list',
    name: 'admin.list',
    component: () => lazyLoadView(import('@views/user/adminList')),
    meta: {
      authRequired: true,
      title: 'Admin List',
      authorize: ['admin'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/user-add',
    name: 'user.add',
    component: () => lazyLoadView(import('@views/user/add')),
    meta: {
      authRequired: true,
      title: 'Add Admin',
      authorize: ['admin', 'college', 'teacher', 'hod', 'administrator'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/login-list',
    name: 'loginHistory.list',
    component: () => lazyLoadView(import('@views/loginHistory/list')),
    meta: {
      authRequired: true,
      title: 'Login Histories',
      authorize: ['admin', 'college', 'teacher'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/course-list',
    name: 'course.list',
    component: () => lazyLoadView(import('@views/course/list')),
    meta: {
      authRequired: true,
      title: 'Course List',
      authorize: ['admin', 'college', 'teacher', 'hod', 'administrator'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/course-add',
    name: 'course.add',
    component: () => lazyLoadView(import('@views/course/course-add')),
    meta: {
      authRequired: true,
      title: 'Course Add',
      authorize: ['admin', 'college', 'teacher', 'hod', 'administrator'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/course-detail/:courseId',
    name: 'course.detail',
    component: () => lazyLoadView(import('@views/course/course-detail')),
    meta: {
      authRequired: true,
      title: 'Course Detail',
      authorize: ['college', 'hod', 'administrator', 'admin', 'teacher'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/add-course-batch/:courseId',
    name: 'add.course.batch',
    component: () => lazyLoadView(import('@views/course/course-batch-add')),
    meta: {
      authRequired: true,
      title: 'Course Batch',
      authorize: ['college', 'hod', 'administrator', 'admin', 'teacher'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/add-course-content/:courseId',
    name: 'add.course.content',
    component: () => lazyLoadView(import('@views/course/course-content-add')),
    meta: {
      authRequired: true,
      title: 'Course content',
      authorize: ['college', 'hod', 'administrator', 'admin', 'teacher'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/list-course-content/:courseId',
    name: 'list.course.content',
    component: () => lazyLoadView(import('@views/course/course-content-list')),
    meta: {
      authRequired: true,
      title: 'Course content',
      authorize: ['college', 'hod', 'administrator', 'admin', 'teacher'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: () => lazyLoadView(import('@views/course/calendar')),
    meta: {
      authRequired: true,
      title: 'Calendar',
      authorize: ['admin', 'college', 'teacher', 'hod', 'administrator'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/calendar-event',
    name: 'calendar.events',
    component: () => lazyLoadView(import('@views/course/calendar-event')),
    meta: {
      authRequired: true,
      title: 'Calendar Events',
      authorize: ['admin', 'college', 'teacher', 'hod'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/calendar-event-add',
    name: 'calendar.events.add',
    component: () => lazyLoadView(import('@views/course/calendar-event-add')),
    meta: {
      authRequired: true,
      title: 'Add Calendar Event',
      authorize: ['admin', 'college', 'teacher', 'hod', 'administrator'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/event-list',
    name: 'event.list',
    component: () => lazyLoadView(import('@views/event/list')),
    meta: {
      authRequired: true,
      title: 'Event List',
      authorize: ['admin', 'college', 'teacher', 'hod', 'administrator'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/event-add',
    name: 'event.add',
    component: () => lazyLoadView(import('@views/event/add')),
    meta: {
      authRequired: true,
      title: 'Add Event',
      authorize: ['admin', 'college', 'teacher', 'hod', 'administrator'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/event-requests',
    name: 'event.requests',
    component: () => lazyLoadView(import('@views/event/requests')),
    meta: {
      authRequired: true,
      title: 'Add Event',
      authorize: ['admin', 'college', 'teacher', 'hod', 'administrator'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/blog-list',
    name: 'blog.list',
    component: () => lazyLoadView(import('@views/blog/list')),
    meta: {
      authRequired: true,
      title: 'Blog List',
      authorize: ['admin', 'college', 'teacher', 'hod', 'administrator'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/blog-add',
    name: 'blog.add',
    component: () => lazyLoadView(import('@views/blog/add')),
    meta: {
      authRequired: true,
      title: 'Add Blog',
      authorize: ['admin', 'college', 'teacher', 'hod', 'administrator'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/college-list',
    name: 'college.list',
    component: () => lazyLoadView(import('@views/college/list')),
    meta: {
      authRequired: true,
      title: 'College List',
      authorize: ['teacher', 'college', 'hod', 'administrator', 'admin'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/college-add',
    name: 'college.add',
    component: () => lazyLoadView(import('@views/college/add')),
    meta: {
      authRequired: true,
      title: 'Add College',
      authorize: ['teacher', 'college', 'hod', 'administrator', 'admin'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/college-class-list',
    name: 'collegeclass.list',
    component: () => lazyLoadView(import('@views/college-class/list')),
    meta: {
      authRequired: true,
      title: 'College Class List',
      authorize: ['teacher', 'college', 'hod', 'administrator', 'admin'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/college-class-add',
    name: 'collegeclass.add',
    component: () => lazyLoadView(import('@views/college-class/add')),
    meta: {
      authRequired: true,
      title: 'Add Class',
      authorize: ['teacher', 'college', 'hod', 'administrator', 'admin'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/department-list',
    name: 'department.list',
    component: () => lazyLoadView(import('@views/department/list')),
    meta: {
      authRequired: true,
      title: 'Department List',
      authorize: ['teacher', 'college', 'hod', 'administrator', 'admin'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/department-add',
    name: 'department.add',
    component: () => lazyLoadView(import('@views/department/add')),
    meta: {
      authRequired: true,
      title: 'Add Department',
      authorize: ['teacher', 'college', 'hod', 'administrator', 'admin'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/batch-list',
    name: 'batch.list',
    component: () => lazyLoadView(import('@views/batch/list')),
    meta: {
      authRequired: true,
      title: 'Batch List',
      authorize: ['teacher', 'college', 'hod', 'administrator'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/batch-add',
    name: 'batch.add',
    component: () => lazyLoadView(import('@views/batch/add')),
    meta: {
      authRequired: true,
      title: 'Add Batch',
      authorize: ['teacher', 'college', 'hod', 'administrator'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/teacher-list',
    name: 'teacher.list',
    component: () => lazyLoadView(import('@views/user/teacherList')),
    meta: {
      authRequired: true,
      title: 'Teacher List',
      authorize: ['college', 'hod', 'administrator', 'admin'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/teacher-add',
    name: 'teacher.add',
    component: () => lazyLoadView(import('@views/user/addTeacher')),
    meta: {
      authRequired: true,
      title: 'Add HOD/Teacher',
      authorize: ['college', 'hod', 'administrator', 'admin'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/resource-list',
    name: 'resource.list',
    component: () => lazyLoadView(import('@views/resources/list')),
    meta: {
      authRequired: true,
      title: 'Resources List',
      authorize: ['college', 'teacher', 'hod', 'administrator', 'admin'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/resource-add',
    name: 'resource.add',
    component: () => lazyLoadView(import('@views/resources/add')),
    meta: {
      authRequired: true,
      title: 'Add Resource',
      authorize: ['college', 'teacher', 'hod', 'administrator', 'admin'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/assignment-list',
    name: 'assignment.list',
    component: () => lazyLoadView(import('@views/assignment/list')),
    meta: {
      authRequired: true,
      title: 'Assignments List',
      authorize: ['college', 'teacher', 'hod', 'administrator', 'admin'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/assignment-list/:id',
    name: 'assignment.detail',
    component: () => lazyLoadView(import('@views/assignment/detail')),
    meta: {
      authRequired: true,
      title: 'Assignments Detail',
      authorize: ['college', 'teacher', 'hod', 'administrator', 'admin'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/assignment-add',
    name: 'assignment.add',
    component: () => lazyLoadView(import('@views/assignment/add')),
    meta: {
      authRequired: true,
      title: 'Add Assignment',
      authorize: ['college', 'teacher', 'hod', 'administrator', 'admin'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/report-list',
    name: 'report.list',
    component: () => lazyLoadView(import('@views/report/list')),
    meta: {
      authRequired: true,
      title: 'Report List',
      authorize: [
        'admin',
        'college',
        'teacher',
        'hod',
        'administrator',
        'admin',
      ],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/report-list/:id',
    name: 'report.list.detail',
    component: () => lazyLoadView(import('@views/report/detail')),
    meta: {
      authRequired: true,
      title: 'Report Detail',
      authorize: [
        'admin',
        'college',
        'teacher',
        'hod',
        'administrator',
        'admin',
      ],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/dynamicreport',
    name: 'report.dynamicreport',
    component: () => lazyLoadView(import('@views/report/dynamicreport')),
    meta: {
      authRequired: true,
      title: 'Dynamic Report',
      authorize: ['admin', 'college', 'teacher', 'hod', 'administrator'],
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/confirm-account',
    name: 'confirm-account',
    component: () => lazyLoadView(import('@views/confirm')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    component: () => lazyLoadView(import('@views/forgetPassword')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/reset-password/:id',
    name: 'reset-password',
    component: () => lazyLoadView(import('@views/resetPassword')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: () => lazyLoadView(import('@views/changePassword')),
    meta: {
      authRequired: true,
      title: 'Change Password',
      authorize: ['admin', 'college', 'teacher', 'hod', 'administrator'],
    },
  },
  {
    path: '/my-profile',
    name: 'my-profile',
    component: () => lazyLoadView(import('@views/profile')),
    meta: {
      authRequired: true,
      title: 'My Profile',
      authorize: ['admin', 'college', 'teacher', 'hod', 'administrator'],
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'home' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  {
    path: '/unathorized',
    name: '422',
    component: require('@views/_422').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 60000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
